import { AccountRowDataGrid, ColumnIndexes, ColumnKeys } from '../../../accounts/accountsGrid/types';
import { ColumnDetails } from '../../../grid/types/common';
import { translateFn } from '../../../utils/translator.helper';
import { FindingClassType, UNAVAILABLE_DATA } from '../../types';
import { relatedFindingsRenderer } from '../../utils/utils';
import { htmlDecode } from '../../../utils/escape.utils';

export function companyRenderer(
  rowData: AccountRowDataGrid,
  columnDetails: ColumnDetails<ColumnIndexes, ColumnKeys>
): HTMLElement {
  const company = rowData.item[columnDetails.key];
  let displayString = translateFn('N/A');
  if (company && company.name) {
    displayString = company.name;
  }

  const companyCell: HTMLElement = document.createElement('div');
  companyCell.innerText = htmlDecode(displayString);
  companyCell.className = 'cell-label';

  return companyCell;
}

export function isVulnerableRenderer(rowData: any): HTMLElement {
  const vulnerableToZoneTransferCell: HTMLElement = document.createElement('div');

  vulnerableToZoneTransferCell.innerText =
    rowData.item.relatedArtifactAreVulnerable !== undefined && rowData.item.relatedArtifactAreVulnerable
      ? translateFn('Yes')
      : translateFn('No');
  vulnerableToZoneTransferCell.className = 'cell-label';

  return vulnerableToZoneTransferCell;
}

export function assetNameRenderer(rowData: any): HTMLElement {
  const assetNameCell: HTMLElement = document.createElement('div');

  assetNameCell.innerText = htmlDecode(rowData.item.name);
  assetNameCell.style.color = 'var(--blue-layout-400-primary)';
  assetNameCell.className = 'cell-label';

  return assetNameCell;
}

export function cvesRenderer(rowData: any): HTMLElement {
  const cvesCell: HTMLElement = document.createElement('div');

  cvesCell.innerText = rowData.item.cvesFromRelatedArtifacts === 0 ? UNAVAILABLE_DATA : rowData.item.cvesFromRelatedArtifacts;
  cvesCell.className = 'cell-label';

  return cvesCell;
}

export function openPortsRenderer(rowData: any): HTMLElement {
  const openPortsCell: HTMLElement = document.createElement('div');

  openPortsCell.innerText =
    rowData.item.openPorts === undefined || rowData.item.openPorts === 0 ? UNAVAILABLE_DATA : rowData.item.openPorts;
  openPortsCell.className = 'cell-label';

  return openPortsCell;
}

export function dnsResolutionRenderer(rowData: any): HTMLElement {
  const dnsResolutionCell: HTMLElement = document.createElement('div');

  dnsResolutionCell.innerText =
    rowData.item.dnsResolutionFailed !== undefined && rowData.item.dnsResolutionFailed
      ? translateFn('Yes')
      : translateFn('No');
  dnsResolutionCell.className = 'cell-label';

  return dnsResolutionCell;
}

export function relatedAssetsRenderer(rowData: any): HTMLElement {
  return relatedFindingsRenderer(rowData, FindingClassType.ASSET, FindingClassType.ASSET);
}

export function relatedArtifactsRenderer(rowData: any): HTMLElement {
  return relatedFindingsRenderer(rowData, FindingClassType.ASSET, FindingClassType.ARTIFACT);
}
